<template>
  <div class="text-center md:px-24 px-5 mt-24 md:mt-48">
    <div class="font-primary uppercase text-5xl font-medium">ÜBER BLACKOUT</div>
    <div class="font-primary text-xl mt-10">
      Schwarz-Weiß-Denken beschreibt eine Denkweise, bei der Menschen dazu
      neigen, komplexe Sachverhalte auf einfache, gegensätzliche Kategorien zu
      reduzieren: gut oder schlecht, richtig oder falsch, Freund oder Feind.
      Diese Denkweise ignoriert die vielen Grautöne und Zwischenstufen, die es
      in der Realität gibt. Es ist eine Vereinfachung, die oft dazu führt, dass
      wichtige Details und Unterschiede übersehen werden. Im Kontext des
      <span class="font-bold">blackout.</span>-Magazins wird Schwarz-Weiß-Denken
      als Herausforderung verstanden, die es zu überwinden gilt. Die Themen des
      Magazins - von gesellschaftlichen Missständen bis hin zu persönlichen
      Erfahrungen mit alkoholbedingten blackouts - sind vielschichtig und
      komplex. Sie lassen sich nicht in einfache Kategorien einordnen.
      <br /><br /><br />
      Die Philosophie von <span class="font-bold">blackout.</span> basiert auf
      Offenheit und Tiefgang. Wir glauben daran, dass nur durch ehrlichen Dialog
      und fundierte Aufklärung eine Veränderung in der Wahrnehmung und im
      Verhalten erzielt werden kann.
      <span class="font-bold">blackout.</span> steht für Authentizität und
      Empathie. Es werden echte Geschichten geteilt, ehrliche Gespräche geführt
      und fundierte Informationen geboten, um die Themen in all ihren Facetten
      zu beleuchten. Denn in <span class="font-bold">blackout.</span> findet
      jegliches Thema Gehör, welches uns oder unsere Gesellschaft beschäftigt.
      Das Ziel: Aufklärung im Einklang mit ästhetischem Design und fesselnder
      Fotografie. Wir setzen uns kritisch mit unterschiedlichsten Themen
      auseinander, die durch <span class="font-bold">blackout.</span> eine Bühne
      bekommen sollen. Dabei wollen wir die Themen von mehr als nur zwei Seiten
      beleuchten, denn kein Thema ist nur schwarz oder weiß - entdecke mit
      <span class="font-bold">blackout.</span> die Graustufen.
    </div>
  </div>
</template>
